import { render, staticRenderFns } from "./ModalComp.vue?vue&type=template&id=7cd938dc&scoped=true"
import script from "./ModalComp.vue?vue&type=script&lang=js"
export * from "./ModalComp.vue?vue&type=script&lang=js"
import style0 from "./ModalComp.vue?vue&type=style&index=0&id=7cd938dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd938dc",
  null
  
)

export default component.exports